/* eslint-disable import/prefer-default-export */
import * as Cookies from 'js-cookie';
import Fingerprint from 'fingerprintjs2';
import { createAction, createActions } from 'redux-actions';

import API from 'shared/constants/api';
import anyMake from 'shared/constants/json/anyMake.json';

import { GLOBALS } from '../constants/actionTypes';

export const journal = createActions({
  journal: {
    setRubrics: undefined,
  },
}).journal;

const directSetRatio = createAction(GLOBALS.RATIO_SET);
export const directSetLocation = createAction(GLOBALS.LOCATION_SET);
export const directSetFingerprint = createAction(GLOBALS.FINGERPRINT_SET);
export const directSetPromoteInSocial = createAction(GLOBALS.PROMOTE_IN_SOCIAL_SET);
export const setTargetingArguments = createAction(GLOBALS.TARGETING_ARGUMENTS_SET);
export const setSeoSearchUrl = createAction(GLOBALS.SEO_SEARCH_URLS);
export const setPaymentModal = createAction(GLOBALS.PAYMENT_SET_MODAL);
export const setDataLayer = createAction(GLOBALS.DATA_LAYER_SET);
export const bannerShow = createAction(GLOBALS.BANNER_SHOW);
export const bannerUpdate = createAction(GLOBALS.BANNER_UPDATE);
export const bannerHide = createAction(GLOBALS.BANNER_HIDE);
export const directSetSeoText = createAction(GLOBALS.SEO_TEXT_SET);
export const directSetDealerSlug = createAction(GLOBALS.DEALER_SLUG_SET);
export const setIsApprovePub = createAction(GLOBALS.SET_IS_APPROVE_PUB);
export const setRedirectUrl = createAction(GLOBALS.SET_REDIRECT_URL);

// start Insurance
export const setInsuranceOrders = createAction(GLOBALS.SET_INSURANCE_ORDERS);
export const setInsuranceRegions = createAction(GLOBALS.SET_INSURANCE_REGIONS);
export const setInsuranceFilters = createAction(GLOBALS.SET_INSURANCE_FILTERS);
export const setInsuranceMakes = createAction(GLOBALS.SET_INSURANCE_MAKES);
export const setSelectedValues = createAction(GLOBALS.SET_SELECTED_VALUES);
export const setSelectedOffer = createAction(GLOBALS.SET_SELECTED_OFFER);
export const setOrderWithHash = createAction(GLOBALS.SET_ORDER_WITH_HASH);
export const setFillData = createAction(GLOBALS.SET_FILL_DATA);
export const setOffersData = createAction(GLOBALS.SET_OFFERS_DATA);
export const setIsNumberBlock = createAction(GLOBALS.SET_IS_NUMBER_BLOCK);
export const setShowConfirmModal = createAction(GLOBALS.SET_SHOW_CONFIRM_MODAL);
export const setOrderForEdit = createAction(GLOBALS.SET_ORDER_FOR_EDIT);
// end Insurance

export const setFingerprint = () => dispatch => {
  try {
    new Fingerprint().get(result => {
      dispatch(directSetFingerprint(result)); // a hash, representing your device fingerprint
    });
  } catch (e) {
    // It's ok if the fingerprint can't be calculated
  }
};

export const clearEditOrder = () => dispatch => {
  dispatch(setOrderForEdit(null));
};

export const clearRedirectUrl = () => dispatch => {
  dispatch(setRedirectUrl(''));
};

export const setPromoteInSocial = value => dispatch => {
  dispatch(directSetPromoteInSocial(value));
};

export const setLocation = location => dispatch => {
  dispatch(directSetLocation(location));
};

export const setRatio = () => (dispatch, getState) => {
  if (!getState().globals.ratio) {
    let ratio = 1;
    const mediaQuery =
      '(-webkit-min-device-pixel-ratio: 1.5), (min--moz-device-pixel-ratio: 1.5),(-o-min-device-pixel-ratio: 3/2),(min-resolution: 1.5dppx)';
    if (process.env.BROWSER && window.devicePixelRatio) {
      ratio = window.devicePixelRatio;
    } else if (process.env.BROWSER && window.matchMedia && window.matchMedia(mediaQuery).matches) {
      ratio = 1.5;
    }

    Cookies.set('ratio', parseFloat(ratio));

    dispatch(directSetRatio(ratio));
  }

  return Promise.resolve(null);
};

export const seoRequest = (url, query, obj = null) => async (dispatch, getState, { fetch }) => {
  const resSeo = url
    ? await fetch(API.SEO.SEARCH_URLS(url, query)).then(r => (r.ok ? r.json() : null))
    : null;

  if (query && query.make === '-1' && resSeo) resSeo.make = anyMake;

  // Currently trends for all pages the same, this is should be changed if trends will be different.
  const { trends: trendsStorage } = getState().globals.seoSearchUrlResponse;
  const trends =
    trendsStorage || (await fetch(API.SEO.SEARCH_TRENDS({})).then(r => (r.ok ? r.json() : null)));
  if (resSeo) {
    resSeo.trends = trends;
  } else {
    dispatch(setSeoSearchUrl({ ...resSeo, ...obj, trends }));
  }

  return resSeo;
};

export const sendCreditEmail = data => (dispatch, getState, { fetch }) =>
  fetch(API.SEND_CREDIT_MAIL, {
    method: 'POST',
    body: JSON.stringify(data),
  })
    .then(async res => {
      const status = res.status;
      const dat = (await res.json()) || {};
      if (status === 200) {
        return dat.message || 'Ваше письмо отправлено';
      }
    })
    .catch(async err => {
      const dat = (await err.json()) || {};
      return (
        dat.message || 'Извините, произошла ошибка на сервере, попробуйте повторить операцию позже'
      );
    });



// WEBPACK FOOTER //
// ./src/shared/actions/globals.js